import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ProblemsAPI } from "../../../api/problems";

export default function ProblemDetail() {
  const { id } = useParams();
  const [problem, setProblem] = useState(null);
  const [message, setMessage] = useState("");

  useEffect(() => {
    ProblemsAPI.get(id).then(setProblem);
  }, [id]);

  async function handleUpdate() {
    await ProblemsAPI.addUpdate(id, { message });
    setMessage("");
    const updated = await ProblemsAPI.get(id);
    setProblem(updated);
  }

  if (!problem) return <div>Loading...</div>;

  return (
    <div>
      <h1 className="text-xl font-bold">{problem.title}</h1>
      <p className="text-gray-500 mb-4">{problem.status}</p>

      {/* Updates */}
      <div className="mb-6">
        <h2 className="font-semibold mb-2">Updates</h2>

        <div className="space-y-2 mb-3">
          {problem.updates.map((u) => (
            <div key={u.id} className="border p-2 rounded">
              {u.message}
            </div>
          ))}
        </div>

        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          className="w-full border rounded p-2"
          placeholder="Post update..."
        />

        <button
          onClick={handleUpdate}
          className="mt-2 bg-blue-600 text-white px-3 py-1 rounded"
        >
          Post Update
        </button>
      </div>

      {/* Linked tickets */}
      <div>
        <h2 className="font-semibold mb-2">Tickets</h2>

        <div className="space-y-2">
          {problem.tickets.map((t) => (
            <Link
              key={t.id}
              to={`/helpdesk/tickets/${t.id}`}
              className="block border p-2 rounded hover:bg-gray-50"
            >
              <div>
                #{t.id} — {t.title}
              </div>
              <div className="text-sm text-gray-500">
                {t.status_name || "Unknown status"}
                {t.school_name ? ` • ${t.school_name}` : ""}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}